import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@bookdental/ui";
import { useAuth } from "@/lib/auth";
import { Avatar } from "@/components/Avatar";
import { OpcoesDoPerfil, type OpcoesDoPerfilProps } from "../OpcoesDoPerfil";

type Props = Omit<OpcoesDoPerfilProps, "aoEscolher" | "grande"> & {
  aberta: boolean;
  onFechar: () => void;
};

/** O menu do perfil no celular: gaveta pela esquerda, como a foto do LinkedIn. */
export function GavetaDoPerfil({ aberta, onFechar, ...tour }: Props) {
  const { user } = useAuth();
  return (
    <Sheet open={aberta} onOpenChange={(v) => !v && onFechar()}>
      <SheetContent
        side="left"
        className="flex w-[85vw] max-w-sm flex-col gap-0 overflow-y-auto border-zinc-200 bg-white p-0 shadow-2xl dark:border-border dark:bg-card"
        style={{ paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="flex items-center gap-3 border-b border-border px-4 py-4 pr-12">
          <Avatar src={user?.image} name={user?.name} size="md" />
          <div className="min-w-0">
            <SheetTitle className="truncate text-base font-semibold text-foreground">{user?.name}</SheetTitle>
            <SheetDescription className="truncate text-xs text-muted-foreground">{user?.email}</SheetDescription>
          </div>
        </div>
        <OpcoesDoPerfil aoEscolher={onFechar} grande {...tour} />
      </SheetContent>
    </Sheet>
  );
}
